import type { CalendarColor, Label } from "@/api";
import { cn } from "@/lib/utils";
import { labelHex } from "@/lib/domain";

/** Multi-select Label chooser. Colours come from Google Calendar's palette. */
export function LabelChips({
  labels,
  colors,
  picked,
  onToggle,
}: {
  labels: Label[];
  colors: CalendarColor[];
  picked: string[];
  onToggle: (id: string) => void;
}) {
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Labels">
      {labels
        .filter(
          (label) =>
            label.system_role !== "external" &&
            label.system_role !== "investment",
        )
        .map((label) => {
          const hex = labelHex(colors, label);
          const on = picked.includes(label.id);
          return (
            <button
              key={label.id}
              type="button"
              aria-pressed={on}
              onClick={() => onToggle(label.id)}
              className={cn(
                "inline-flex items-center gap-2 rounded-full border px-3 py-1 text-sm transition-colors",
                on
                  ? "border-primary bg-primary text-primary-foreground"
                  : "border-border bg-card text-foreground hover:bg-secondary",
              )}
            >
              <span
                className="h-2.5 w-2.5 rounded-full border border-black/10 bg-muted-foreground"
                style={hex ? { backgroundColor: hex } : undefined}
                aria-hidden
              />
              {label.name}
            </button>
          );
        })}
    </div>
  );
}
